import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Delete this as part of berry-4386-add-helpcenterid-to-routes FG clean up
export const helpCenterSettingsKbOldRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-kb-old',
	path: '/jira/helpcenter/projects/:projectKey/settings/kb',
	exact: true,
};
